export { default } from './carousel-navigation.component'
export type { NavigationProps } from './carousel-navigation.component'
